import React from 'react'
import PropTypes from 'prop-types'

import itemStyles from '../../assets/stylesheets/pages/cart/items.module.scss'
import ratingStyles from '../../assets/stylesheets/pages/sale_products/ratings.module.scss'

const SaleRatings = (props) => {
  const { overallRating, simpleRatings } = props

  return (
    <div className={itemStyles.sale_ratings}>
      ({overallRating.name})
      {simpleRatings.map((rating, index) => {
        return (
          <span
            key={index}
            className={ratingStyles[rating.varName]}
          >
            {rating.value}
          </span>
        )
      })}
    </div>
  )
}

SaleRatings.propTypes = {
  overallRating: PropTypes.object,
  simpleRatings: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    rating: PropTypes.object
  }))
}

export default SaleRatings
